import {
  FormControl,
  Label,
  LabelText,
  SingleLineInput,
  Textarea,
  ValidationErrorMessage,
} from "@sourceful/design-system-v3";
import { SanityFormTextField } from "@sourceful/shared-utils/sanity-utils";
import SanityRequiredFieldIndicator from "./SanityRequiredFieldIndicator";
import { FieldMeta } from "@tanstack/react-form";

interface SanityFormTextProps {
  field: SanityFormTextField;
  className?: string;
  defaultValue?: string;
  fieldMeta?: FieldMeta;
  onChange?: (e: any) => void;
}

export default function SanityFormText({
  field,
  className,
  defaultValue,
  fieldMeta,
  onChange,
}: Readonly<SanityFormTextProps>) {
  return (
    <FormControl key={field.id} layout="column" className={className}>
      <Label labelFor={field.id}>
        <LabelText>
          {field.label}

          {field.isRequired ? <SanityRequiredFieldIndicator /> : ""}
        </LabelText>
      </Label>
      {field.displayType === "input" ? (
        <SingleLineInput
          id={field.id}
          name={field.id}
          placeholder={field.placeholder}
          type={field.dataType === "email" ? "email" : "text"}
          required={field.isRequired}
          defaultValue={defaultValue}
          onChange={e => {
            onChange && onChange(e.target.value);
          }}
          onBlur={e => {
            onChange && onChange(e.target.value);
          }}
          error={!!fieldMeta?.errors.length}
        />
      ) : (
        <Textarea
          id={field.id}
          name={field.id}
          placeholder={field.placeholder}
          required={field.isRequired}
          defaultValue={defaultValue}
          onChange={e => {
            onChange && onChange(e.target.value);
          }}
          onBlur={e => {
            onChange && onChange(e.target.value);
          }}
          error={!!fieldMeta?.errors.length}
        />
      )}
      {fieldMeta?.errors ? (
        <ValidationErrorMessage inputId={field.id}>{fieldMeta.errors}</ValidationErrorMessage>
      ) : (
        ""
      )}
    </FormControl>
  );
}
